import whatIsCfdTradingContent from './content/what-is-cfd-trading.json';

const whatIsCfdTradingMock = {
    layoutType: 2,
    data: {
        name: 'what-is-cfd-trading',
        layoutType: 2,
        areasList: [
            {
                id: 'what-is-cfd-trading-page-area',
                name: 'Content',
                componentName: 'Comp:WhatIsCfdTradingPage',
                content: JSON.stringify(whatIsCfdTradingContent),
            },
        ],
    },
};

export default whatIsCfdTradingMock;
